import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/dentlab/src/components/ui/select";
import { NEW_VENDOR_ID } from "../../types";

export interface OrganizationSelectOption {
	id: string;
	name: string;
}

interface OrganizationSelectProps {
	organizations: OrganizationSelectOption[];
	selectedOrganizationId: string;
	setSelectedOrganizationId: (organizationId: string) => void;
}

export const OrganizationSelect: React.FC<OrganizationSelectProps> = ({
	organizations,
	selectedOrganizationId,
	setSelectedOrganizationId,
}) => {
	return (
		<div>
			<Select
				value={selectedOrganizationId || undefined}
				onValueChange={setSelectedOrganizationId}
			>
				<SelectTrigger className="w-[180px]">
					<SelectValue placeholder="Wähle ein Fremdlabor" />
				</SelectTrigger>
				<SelectContent>
					<SelectGroup>
						<SelectItem value={NEW_VENDOR_ID}>
							Neues Fremdlabor
						</SelectItem>
						{organizations.map((organization) => (
							<SelectItem
								key={organization.id}
								value={organization.id}
							>
								{organization.name}
							</SelectItem>
						))}
					</SelectGroup>
				</SelectContent>
			</Select>
		</div>
	);
};
